
<template>
  <div class="l-main">
    <div class="c-reserve-comp">
      <div class="c-reserve-comp--message">
        <p>
          資料をご請求いただき、ありがとうございました。<br />
          内容確認後、改めてこちらからご連絡差し上げます。
        </p>
      </div>
      <div class="c-reserve-comp--button">
        <a class="c-reserve-comp--button__confirm" href="/">
          TOPページへ
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentRequestComplete',
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@charset "UTF-8";
.l-main {
  padding: 30px 0;
  .c-reserve-comp {

    &--message {
      p {
        font-size: 16px;
        text-align: center;
        line-height: 1.5em;
      }
    }

    &--button {
      display:flex;
      justify-content: center;
      align-items: center;
      margin-top:50px;
      a {
        height: 55px;
        width: 352px;
        font-size: 18px;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight:bold;
      }
      &__back {
        width:152px;
        border: 1px solid #CCC;
        background-color:#FFF;
        position: absolute;
        left:0;
      }
      &__confirm {
        color: #FFF;
        width: 264px;
        background-color: #E83532;
      }
    }
  }

}

@media screen and (max-width: 767px) {
  a {
    width: 100%;
  }

}

</style>
